const ProductRipplingLogo = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="none"
    height="49"
    viewBox="0 0 48 49"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9914_257)" id="Rippling Flat">
      <path
        d="M40.5 0.0625H7.5C3.35786 0.0625 0 3.42036 0 7.5625V40.5625C0 44.7046 3.35786 48.0625 7.5 48.0625H40.5C44.6421 48.0625 48 44.7046 48 40.5625V7.5625C48 3.42036 44.6421 0.0625 40.5 0.0625Z"
        fill="#FDB71C"
        id="Vector"
      />
      <path
        d="M13.0946 19.2652C13.0946 16.8959 11.8906 14.9378 9.64062 13.293H14.8709C16.7064 14.7028 17.8314 16.8568 17.8314 19.2652C17.8314 21.6737 16.7064 23.8277 14.8709 25.2375C16.5683 25.9424 17.5354 27.6656 17.5354 30.1328V34.8323H12.7985V30.1328C12.7985 27.7831 11.6735 26.1383 9.64062 25.2375C11.8906 23.5927 13.0946 21.6346 13.0946 19.2652ZM23.3578 19.2652C23.3578 16.8959 22.1538 14.9378 19.9038 13.293H25.1341C26.9696 14.7028 28.0946 16.8568 28.0946 19.2652C28.0946 21.6737 26.9696 23.8277 25.1341 25.2375C26.8315 25.9424 27.7986 27.6656 27.7986 30.1328V34.8323H23.0617V30.1328C23.0617 27.7831 21.9367 26.1383 19.9038 25.2375C22.1538 23.5927 23.3578 21.6346 23.3578 19.2652ZM33.6229 19.2652C33.6229 16.8959 32.419 14.9378 30.169 13.293H35.3992C37.2348 14.7028 38.3598 16.8568 38.3598 19.2652C38.3598 21.6737 37.2348 23.8277 35.3992 25.2375C37.0966 25.9424 38.0637 27.6656 38.0637 30.1328V34.8323H33.3269V30.1328C33.3269 27.7831 32.2019 26.1383 30.169 25.2375C32.419 23.5927 33.6229 21.6346 33.6229 19.2652Z"
        fill="#502D3C"
        id="Vector_2"
      />
    </g>
    <defs>
      <clipPath id="clip0_9914_257">
        <rect
          fill="white"
          height="48"
          transform="translate(0 0.0625)"
          width="48"
        />
      </clipPath>
    </defs>
  </svg>

);

export default ProductRipplingLogo;
